// extracted by mini-css-extract-plugin
module.exports = {"content":"loanMkk_content__OYAm9","link":"loanMkk_link__wY_Rp"};